"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_sql_parser_1 = require("node-sql-parser");
const SQLPREFIX = 'SELECT * FROM UNKNOWN';
const CONDITION_OPERATORS = ['and', 'or'];
const DEFAULT_OPTIONS = {
    likeOpsCaseSensitive: false,
    multipleLineSql: false,
    database: 'mysql', // todo support multiple databases
};
class SQLParser {
    constructor(option) {
        this.generateMongoQuery = (whereConditon) => {
            try {
                let { operator } = whereConditon;
                const { left, right } = whereConditon;
                if (!operator) {
                    throw new Error('Invalid SQL statement, Please check your SQL statement where condition.');
                }
                if (!left && !right && operator) {
                    throw new Error(`Operator '${operator}' not currently supported.`);
                }
                operator = operator.toLowerCase();
                const { column: leftColumn, type: leftType } = left;
                const { column: rightColumn, type: rightType, value } = right;
                if (rightType === 'expr_list') {
                    const exprs = [];
                    try {
                        if (Array.isArray(value)) {
                            value.forEach((v) => {
                                if (v.type === 'select') {
                                    exprs.push(this.parser.sqlify(v));
                                }
                            });
                        }
                    }
                    catch (error) {
                        throw error;
                    }
                    if (exprs.length > 0) {
                        throw new Error(`The value: '${exprs.join(';')}' on the ${operator.toUpperCase()} operator right is not currently supported.`);
                    }
                }
                if (leftColumn) {
                    let isCompareColumn = false;
                    if (leftType === rightType && leftType === 'column_ref') {
                        isCompareColumn = true;
                    }
                    switch (operator) {
                        case '=':
                            if (isCompareColumn) {
                                return { $expr: { $eq: [`$${leftColumn}`, `$${rightColumn}`] } };
                            }
                            return { [leftColumn]: this.processRightValue(right) };
                        case '!=':
                        case '<>':
                            if (isCompareColumn) {
                                return { $expr: { $ne: [`$${leftColumn}`, `$${rightColumn}`] } };
                            }
                            return { [leftColumn]: { $ne: this.processRightValue(right) } };
                        case 'is not':
                            return { [leftColumn]: { $ne: this.processRightValue(right) } };
                        case '>':
                            if (isCompareColumn) {
                                return { $expr: { $gt: [`$${leftColumn}`, `$${rightColumn}`] } };
                            }
                            return { [leftColumn]: { $gt: this.processRightValue(right) } };
                        case '<':
                            if (isCompareColumn) {
                                return { $expr: { $lt: [`$${leftColumn}`, `$${rightColumn}`] } };
                            }
                            return { [leftColumn]: { $lt: this.processRightValue(right) } };
                        case '>=':
                            if (isCompareColumn) {
                                return { $expr: { $gte: [`$${leftColumn}`, `$${rightColumn}`] } };
                            }
                            return { [leftColumn]: { $gte: this.processRightValue(right) } };
                        case '<=':
                            if (isCompareColumn) {
                                return { $expr: { $lte: [`$${leftColumn}`, `$${rightColumn}`] } };
                            }
                            return { [leftColumn]: { $lte: this.processRightValue(right) } };
                        case 'is':
                            return { [leftColumn]: this.processRightValue(right) };
                        case 'like':
                            return this.processLikeOperator(left, right, true);
                        case 'not like':
                            return this.processLikeOperator(left, right, false);
                        case 'in':
                            return { [leftColumn]: { $in: this.processRightValue(right) } };
                        case 'not in':
                            return { [leftColumn]: { $nin: this.processRightValue(right) } };
                        case 'between':
                            return { [leftColumn]: this.processRightValue(right, 'between') };
                        case 'not between':
                            return { [leftColumn]: { $not: this.processRightValue(right, 'between') } };
                        default:
                            throw new Error(`Operator '${operator.toUpperCase()}' not currently supported.`);
                    }
                }
                if (right && left) {
                    if (CONDITION_OPERATORS.indexOf(operator) > -1) {
                        return { [`$${operator}`]: [this.generateMongoQuery(left), this.generateMongoQuery(right)] };
                    }
                }
                return {};
            }
            catch (error) {
                throw error;
            }
        };
        this.preCheckSql = (sqlQuery) => {
            sqlQuery = sqlQuery.trim();
            if (/^where\s.*/gmi.test(sqlQuery)) {
                sqlQuery = `${SQLPREFIX} ${sqlQuery}`;
            }
            if (/^select\s.*\sfrom\s\w+$/gmi.test(sqlQuery) || /^select\s.*\sfrom\s.*\swhere\s.*/gmi.test(sqlQuery)) {
                try {
                    const sqlAsts = this.parser.astify(sqlQuery);
                    if (this.option.multipleLineSql) {
                        return sqlAsts;
                    }
                    return Array.isArray(sqlAsts) ? sqlAsts[0] : sqlAsts;
                }
                catch (error) {
                    throw error;
                }
            }
            else {
                throw new Error('Invalid SQL statement or the SQL statement not currently supported.');
            }
        };
        this.parseSql = (sqlQuery) => {
            if (!sqlQuery || !sqlQuery.trim()) {
                return {};
            }
            const processAst = (ast) => {
                const { where } = ast;
                if (where) {
                    return this.generateMongoQuery(where);
                }
                return {};
            };
            const sqlAst = this.preCheckSql(sqlQuery);
            if (sqlAst) {
                if (Array.isArray(sqlAst)) {
                    return sqlAst.map(ast => processAst(ast));
                }
                return processAst(sqlAst);
            }
            return {};
        };
        this.getSelectedFeilds = (sqlQuery) => {
            if (!sqlQuery || !sqlQuery.trim()) {
                return {};
            }
            const processAst = (ast) => {
                const { columns } = ast;
                if (columns === '*') {
                    return {};
                }
                if (Array.isArray(columns)) {
                    const fileds = {};
                    columns.forEach((col) => {
                        const { column, type } = col.expr;
                        if (type === 'column_ref') {
                            fileds[column] = 1;
                        }
                    });
                    return fileds;
                }
                return {};
            };
            const sqlAst = this.preCheckSql(sqlQuery);
            if (sqlAst) {
                if (Array.isArray(sqlAst)) {
                    return sqlAst.map(ast => processAst(ast));
                }
                return processAst(sqlAst);
            }
            return {};
        };
        this.getSelectedTable = (sqlQuery) => {
            if (!sqlQuery || !sqlQuery.trim()) {
                return 'UNKNOWN';
            }
            const processAst = (ast) => {
                const { from } = ast;
                return from[0].table;
            };
            const sqlAst = this.preCheckSql(sqlQuery);
            if (sqlAst) {
                if (Array.isArray(sqlAst)) {
                    return sqlAst.map(ast => processAst(ast));
                }
                else {
                    return processAst(sqlAst);
                }
            }
            return 'UNKNOWN';
        };
        this.parser = new node_sql_parser_1.Parser();
        this.option = { ...DEFAULT_OPTIONS, ...option };
    }
    processRightValue(right, operator) {
        const processDate = (value) => {
            const { type, value: valueStr } = value;
            if (type === 'string') {
                const date = new Date(valueStr);
                if (date instanceof Date && !isNaN(date.getTime())) {
                    return date;
                }
            }
            return valueStr;
        };
        const { value, type } = right;
        const valueStr = String(value);
        if (type === 'number') {
            return Number(value);
        }
        if (type === 'bool') {
            return Boolean(value);
        }
        if (type === 'null') {
            return null;
        }
        if (type === 'expr_list') {
            if (Array.isArray(value)) {
                if (operator === 'between') {
                    return { $gte: processDate(value[0]), $lte: processDate(value[1]) };
                }
                return value.map((v) => v.value);
            }
            return [];
        }
        if (type === 'string') {
            return processDate({ type: 'string', value: valueStr });
        }
        return valueStr;
    }
    processLikeOperator(left, right, isLike) {
        const { column } = left;
        const { value } = right;
        let valueStr = String(value);
        let prefix = '';
        let suffix = '';
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        valueStr = valueStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const values = valueStr.split('/%');
        const finalyValues = values.map((val) => {
            while (val.indexOf('%%') > -1) {
                val = val.replace('%%', '%');
            }
            return val.replace(/%/g, '.*');
        });
        let finallyStr = finalyValues.join('%');
        if (/^(\.\*).*(?<!\.\*)$/gi.test(finallyStr)) {
            finallyStr = finallyStr.substr(2);
            suffix = '$';
        }
        if (/^(?!\.\*).*(\.\*)$/gi.test(finallyStr)) {
            finallyStr = finallyStr.substr(0, finallyStr.length - 2);
            prefix = '^';
        }
        const regexStr = `${prefix}${finallyStr}${suffix}`;
        if (this.option.likeOpsCaseSensitive) {
            return isLike ? { [column]: { $regex: regexStr } }
                : { [column]: { $not: new RegExp(regexStr) } };
        }
        return isLike ? { [column]: { $regex: regexStr, $options: 'i' } }
            : { [column]: { $not: new RegExp(regexStr, 'i') } };
    }
}
exports.default = SQLParser;
//# sourceMappingURL=SQLParser.js.map